import moment from "moment";
import { Box, HStack, Text, VStack } from "native-base";
import React from "react";
import { FlatList } from "react-native";

import FormButton from "@/components/atoms/FormButton";
import EmptyList from "@/components/molecules/EmptyList";
import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";
import { formatToCurrency } from "@/utils/helpers";

import OrderStatusBadge from "../components/OrderStatusBadge";
import OrderListLoading from "./components/OrderListLoading";
import { OrderListScreenProps } from "./types";

const OrderListMobile = ({
  orders,
  isLoading,
  onGoBack,
  onLoadMore,
  onPressRepeatOrder,
  onSelectOrder,
}: OrderListScreenProps) => {
  return (
    <Container px="2" Header={<MobileHeader title="Meus Pedidos" onBackPress={onGoBack} />}>
      {isLoading ? (
        <OrderListLoading />
      ) : (
        <FlatList
          data={orders || []}
          nestedScrollEnabled
          keyExtractor={(item, index) => (item ? item._id : String(index))}
          showsVerticalScrollIndicator={false}
          onEndReached={onLoadMore}
          onEndReachedThreshold={0.1}
          contentContainerStyle={{
            marginBottom: 100,
          }}
          renderItem={({ item: order }) => (
            <VStack m="2" p="2" bgColor="white.50" shadow="4" rounded="md" space="2">
              <HStack py="2" space="2" alignItems="center">
                <Box borderColor="primary.600" borderWidth={1} rounded="md" p="1">
                  <Text fontSize="md" bold>
                    {moment(order.agendado ? order.dataAgendamento : order.createdAt).format(
                      "DD/MM/YYYY"
                    )}
                  </Text>
                </Box>
                <OrderStatusBadge orderStatus={order.status} />
              </HStack>
              <Text fontSize="lg" bold>
                {order?.estabelecimento?.nome_fantasia}
              </Text>
              <Text fontSize="lg">
                Valor total:{" "}
                <Text color="primary.600" bold>
                  {formatToCurrency(order.valor_total)}
                </Text>
              </Text>
              <HStack justifyContent="space-between" alignItems="center">
                <FormButton
                  flex={0.45}
                  colorScheme="white"
                  textColor="primary.600"
                  onPress={() => onPressRepeatOrder(order)}>
                  Repetir pedido
                </FormButton>
                <FormButton flex={0.45} onPress={() => onSelectOrder(order._id)}>
                  Ver pedido
                </FormButton>
              </HStack>
            </VStack>
          )}
          ListEmptyComponent={
            <Box py="8">
              <EmptyList />
              <Text py="6" textAlign="center" fontSize="lg">
                Aproveite para fazer sua primeira compra!
              </Text>
            </Box>
          }
        />
      )}
    </Container>
  );
};

export default OrderListMobile;
